import { render } from "./MultiEditText.vue?vue&type=template&id=7a23dee8"
import script from "./MultiEditText.vue?vue&type=script&lang=js"
export * from "./MultiEditText.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__